import React, { useEffect, useState, useRef } from 'react'
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import { Box, Button, DialogActions, DialogContent, FormControlLabel, Radio, RadioGroup, Stack, Typography } from '@mui/material';

const options: TLevelHandlerOption[] = [
    'No activar',
    '1 mes',
    '2 meses',
    '3 meses',
    '4 meses',
    '5 meses',
    '6 meses',
    'Por siempre'
];

const LevelHandler = (props: ILevelHandlerProps) => {
    const {
        onClose,
        onSubmit,
        open,
        payload
    } = props;
    const [currentOption, setCurrentOption] = useState<TLevelHandlerOption>('No activar');

    useEffect(() => {
        if (payload === undefined) {
            setCurrentOption('No activar');
        } else {
            let raw = payload.activation;
            let option: TLevelHandlerOption = 'No activar';

            if (raw === undefined) option = 'No activar';
            else if (raw === 'UNLIMITED') option = 'Por siempre';
            else {
                if (raw === 30) option = '1 mes';
                else if (raw === 60) option = '2 meses';
                else if (raw === 90) option = '3 meses';
                else if (raw === 120) option = '4 meses';
                else if (raw === 150) option = '5 meses';
                else if (raw === 180) option = '6 meses';
            }
            setCurrentOption(option);
        }
    }, [payload, open]);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const opt = (event.target as HTMLInputElement).value;
        setCurrentOption(opt as TLevelHandlerOption);
    };

    const isDisabled = payload === undefined;

    const handleOnSubmit = () => {
        if (isDisabled) return;

        let raw: TLevelActivation = undefined;
        let option = currentOption;

        if (option === 'No activar') raw = undefined;
        else if (option === 'Por siempre') raw = 'UNLIMITED';
        else if (option === '1 mes') raw = 30;
        else if (option === '2 meses') raw = 60;
        else if (option === '3 meses') raw = 90;
        else if (option === '4 meses') raw = 120;
        else if (option === '5 meses') raw = 150;
        else if (option === '6 meses') raw = 180;

        onSubmit({
            id: payload.id,
            name: payload.name,
            activation: raw,
        });

        onClose();
    }


    return (
        <>
            <Dialog
                maxWidth="xs"
                open={open}
                onClose={onClose}
            >
                <DialogTitle>Actualizar duración</DialogTitle>
                <DialogContent dividers>
                    <Stack spacing={1}>
                        <Typography variant="h6">
                            Duración
                        </Typography>
                        {payload !== undefined && (
                            <Typography variant="subtitle1">
                                Define la duración del nivel <em>{payload.name}</em>.
                            </Typography>
                        )}
                        <RadioGroup
                            aria-label="ringtone"
                            name="ringtone"
                            value={currentOption}
                            onChange={handleChange}
                        >
                            {options.map((option) => (
                                <FormControlLabel
                                    value={option}
                                    key={option}
                                    control={<Radio />}
                                    label={option}
                                />
                            ))}
                        </RadioGroup>
                    </Stack>
                </DialogContent>
                <DialogActions>
                    <Stack spacing={2} direction='row'>
                        <Button autoFocus onClick={onClose}>
                            Cancel
                        </Button>
                        <Button onClick={handleOnSubmit} disabled={isDisabled}>Actualizar</Button>
                    </Stack>
                </DialogActions>
            </Dialog>
        </>

    );
};


export { LevelHandler };